/* eslint-env browser, amd */
require('owl.carousel');

(function($) {
    'use strict';

    var owlReference = $('#referencecarousel .owl-carousel');
    var owlReferenceDuration = 1600;

    $(document).ready(function() {
        owlReference.owlCarousel({
            loop: true,
            autoplay: true,
            autoplaytimeout: owlReferenceDuration,
            autoplayHoverPause: true,
            margin: 0,
            responsiveClass: true,
            navText: ['<i class="icon icon-prev"></i>', '<i class="icon icon-next"></i>'],
            nav: true,
            responsive: {
                0: {
                    items: 2
                },
                480: {
                    items: 3
                },
                768: {
                    items: 4
                },
                970: {
                    items: 5
                }
            }
        });
    });
})(jQuery);



//////////////////
// WEBPACK FOOTER
// ./source/javascript/es5/owlcarousel.js
// module id = 4
// module chunks = 0